import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-store-list",
  "use": "icon-store-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-store-list\"><path d=\"M992 960H32a32 32 0 0 1-32-32V320a32 32 0 0 1 32-32h960a32 32 0 0 1 32 32v608a32 32 0 0 1-32 32zM64 896h896V348.8H64z\" p-id=\"11794\" /><path d=\"M800 545.28h-576A32 32 0 0 1 192 512a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32 32 32 0 0 1-32 33.28zM480 720h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64zM768 339.2a30.08 30.08 0 0 1-22.4-9.6L512 96.64 278.4 329.6a31.36 31.36 0 1 1-44.8-44.8l256-256a30.72 30.72 0 0 1 44.8 0l256 256a30.72 30.72 0 0 1 0 44.8 30.08 30.08 0 0 1-22.4 9.6z\" p-id=\"11795\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/store-list.svg
// module id = Lwy5
// module chunks = 67